export const features = {
  auditLog: 'audit log',
  productionData: 'production data',
  accessCtrl: 'access control',
  dailyInspection: 'daily inspection'
};
